/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { cn } from '../../../lib';

export type DrawerIconProps = {
  css?: SerializedStyles;
  expanded?: boolean;
  onClick?: () => void;
  cypressId: string;
  className?: string;
};

const svgVariants = {
  initial: { opacity: 0, scale: 0.93 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.93 },
};

const DrawerIcon: React.FC<DrawerIconProps> = ({
  css: propsCss,
  expanded,
  onClick,
  cypressId,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      aria-label="Link Menu"
      cy-data={`drawer-icon-button${cypressId ? `-${cypressId}` : ''}`}
      className={cn('my-cove-15 relative h-9 w-9 bg-inherit', props.className)}
      {...props}
    >
      <AnimatePresence>
        {expanded ? (
          <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            fill="none"
            className="h-full w-full"
            variants={svgVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <rect
              x="11.6362"
              y="13.0502"
              width="2"
              height="16"
              transform="rotate(-45 11.6362 13.0502)"
              fill="#002334"
            />
            <rect
              x="11.6362"
              y="22.9498"
              width="16"
              height="2"
              transform="rotate(-45 11.6362 22.9498)"
              fill="#002334"
            />
          </motion.svg>
        ) : (
          <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            fill="none"
            className="h-full w-full"
            variants={svgVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <path d="M7 9.99951H29" stroke="#002334" strokeWidth="2" />
            <path d="M7 17.9995H29" stroke="#002334" strokeWidth="2" />
            <path d="M7 25.9995H29" stroke="#002334" strokeWidth="2" />
          </motion.svg>
        )}
      </AnimatePresence>
    </button>
  );
};

export default DrawerIcon;
